export default __webpack_public_path__ + "static/media/sent pic.a5aaba2e.svg";